import Vue from 'vue'
import _ from 'lodash'
import axios from 'axios'

// const requestMap = {}
const { CancelToken } = axios
let source = CancelToken.source()

const xhttp = axios.create()

const beforeRequest = config => {
    config.cancelToken = source.token

    return config
}

const successHandler = response => {
    const {
        status, headers, data: res,
    } = response
    // if (config.method === 'get' && requestMap[config.url]) {
    //     delete requestMap[config.url]
    // }
    if (headers['api-type'] === 'restful') {
        if ((status >= 200 && status < 300) || res) {
            return res
        }
    } else if (res.code === 200 || res.result) {
        return res.data
    }

    Vue.prototype.$message.error(res.msg)

    return Promise.reject(
        new Error({
            data: res.data,
            message: res.msg,
            code: res.code,
            toString() {
                return this.message
            },
        })
    )
}

const errorHandler = error => {
    const { status, data: res, headers } = error.response
    const serverErrorText = '服务器异常，请联系管理员'

    const loginHandler = () => {
        const message = res.msg || res.error || '登录失效，请重新登录！'
        Vue.prototype.$message.error(message)

        source.cancel()
        source = CancelToken.source()

        return Promise.reject(new Error(message))
    }

    const noPermissionHandler = () => {
        const message = '暂无权限访问，请联系管理员'
        Vue.prototype.$message.error(message)

        source.cancel()
        source = CancelToken.source()

        return Promise.reject(new Error(message))
    }

    const statusObj = {
        400: loginHandler,
        401: loginHandler,
        403: noPermissionHandler,
        404: '请求地址异常，请联系管理员',
        405: serverErrorText,
        500: serverErrorText,
        502: serverErrorText,
        503: serverErrorText,
        504: '请求超时，请稍后重试',
    }

    if (headers['tenant-permission-limit']) {
        setTimeout(() => {
            const { origin, protocol } = window.location
            const env = (origin.match(/studio-(dev|test|beta)/) || [])[1]
            const envfix = env ? `-${env}` : ''
            const url = protocol.includes('https')
                ? `https://app${envfix}.mypaas.com.cn/package-details`
                : `https://app${envfix}.mypaas.com.cn/#/package-details`
            window.open(url)
        }, 600)
    }

    if (!error.response) {
        return Promise.reject(
            new Error({
                message: '网络连接失败',
                code: -1,
                toString() {
                    return this.message
                },
            })
        )
    }

    const result = statusObj[status]
    let errorText = result || serverErrorText

    if (_.isFunction(result)) {
        return result()
    }
    if (headers['api-type'] === 'restful') {
        errorText = res.error || result || serverErrorText
    }

    Vue.prototype.$message.error(errorText)

    return Promise.reject(errorText)
}

xhttp.interceptors.request.use(beforeRequest)
xhttp.interceptors.response.use(successHandler, errorHandler)

export default xhttp
